export const applyCMSImageFilters = (baseImageUrl, width, height = 0, transformToWebp = true) => {
    return `${baseImageUrl}/m/${width}x${height}${transformToWebp ? '/filters:format(webp)' : ''}`;
};
